import { Location } from '@angular/common';
import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  HostBinding,
} from '@angular/core';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { HeaderComponent } from '@rd/core/containers/header/header.component';
import {
  AssetService,
  AssetType,
} from '@rd/core/services/asset-service/asset.service';
import { NavLinksService } from '@rd/core/services/dropdown-link-items/nav-links.service';
import { GuardhouseService } from '@rd/core/services/guardhouse/guardhouse.service';
import { PointsNumberService } from '@rd/core/services/points-number/points-number.service';
import { UrlUtilsService } from '@rd/core/services/url-utils/url-utils.service';
import { CoreState } from '@rd/core/store/reducers';
import { isNotNull } from '@rd/utils/isNotNull';

@Component({
  selector: 'vma-core-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class VmaHeaderComponent extends HeaderComponent {
  @HostBinding('class.vma-core-header') componentClass = true;

  constructor(
    protected cdRef: ChangeDetectorRef,
    protected guardhouseService: GuardhouseService,
    protected navLinksService: NavLinksService,
    protected location: Location,
    protected router: Router,
    protected urlUtilsService: UrlUtilsService,
    protected store: Store<CoreState>,
    private pointsNumberService: PointsNumberService,
    private assetsService: AssetService,
  ) {
    super(
      cdRef,
      guardhouseService,
      navLinksService,
      location,
      router,
      urlUtilsService,
      store,
    );
  }

  get pointsBalance(): string | undefined {
    if (isNotNull(this.pointsSummary.pointsBalance)) {
      return this.pointsNumberService.roundNumber(
        this.pointsSummary.pointsBalance,
      );
    }
  }

  logoImageUrl(): string {
    return this.assetsService.getAssetPath('header-logo.svg', AssetType.Image);
  }
}
